"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItemsAPI = exports.ItemRarityEnum = void 0;
const burn_1 = require("./burn");
const mint_1 = require("./mint");
const getByCombo_1 = require("./getByCombo");
const getOwnedBy_1 = require("./getOwnedBy");
const getParentsByCombo_1 = require("./getParentsByCombo");
var ItemRarityEnum_1 = require("./ItemRarityEnum");
Object.defineProperty(exports, "ItemRarityEnum", { enumerable: true, get: function () { return ItemRarityEnum_1.ItemRarityEnum; } });
class ItemsAPI {
    baseUrl;
    constructor(baseUrl) {
        this.baseUrl = baseUrl;
    }
    burn = burn_1.burn;
    mint = mint_1.mint;
    getByCombo = getByCombo_1.getByCombo;
    getOwnedBy = getOwnedBy_1.getOwnedBy;
    getParentsByCombo = getParentsByCombo_1.getParentsByCombo;
}
exports.ItemsAPI = ItemsAPI;
//# sourceMappingURL=index.js.map